const allData = [
  {
    name: '1984',
    Undergraduate: 6.1,
    Graduate: 4,
    'Undergraduate and graduate': 5.5,
    'California K-12 public schools': 27.9,
  },
  {
    name: '1985',
    Undergraduate: 7,
    Graduate: 4.1,
    'Undergraduate and graduate': 6.1,
    'California K-12 public schools': 28.7,
  },
  {
    name: '1986',
    Undergraduate: 7.7,
    Graduate: 3.8,
    'Undergraduate and graduate': 6.6,
    'California K-12 public schools': 29.6,
  },
  {
    name: '1987',
    Undergraduate: 9.2,
    Graduate: 4.4,
    'Undergraduate and graduate': 7.8,
    'California K-12 public schools': 30.1,
  },
  {
    name: '1988',
    Undergraduate: 10.9,
    Graduate: 4.5,
    'Undergraduate and graduate': 9.1,
    'California K-12 public schools': 31.4,
  },
  {
    name: '1989',
    Undergraduate: 12.7,
    Graduate: 4.8,
    'Undergraduate and graduate': 10.5,
    'California K-12 public schools': 33,
  },
  {
    name: '1990',
    Undergraduate: 14.2,
    Graduate: 5.2,
    'Undergraduate and graduate': 11.5,
    'California K-12 public schools': 34.4,
  },
  {
    name: '1991',
    Undergraduate: 14.7,
    Graduate: 5.7,
    'Undergraduate and graduate': 12.1,
    'California K-12 public schools': 35.3,
  },
  {
    name: '1992',
    Undergraduate: 14.2,
    Graduate: 5.8,
    'Undergraduate and graduate': 11.8,
    'California K-12 public schools': 36.1,
  },
  {
    name: '1993',
    Undergraduate: 13.7,
    Graduate: 6.1,
    'Undergraduate and graduate': 11.5,
    'California K-12 public schools': 37.1,
  },
  {
    name: '1994',
    Undergraduate: 13.3,
    Graduate: 6.4,
    'Undergraduate and graduate': 11.3,
    'California K-12 public schools': 37.9,
  },
  {
    name: '1995',
    Undergraduate: 13.6,
    Graduate: 6.4,
    'Undergraduate and graduate': 11.5,
    'California K-12 public schools': 38.7,
  },
  {
    name: '1996',
    Undergraduate: 13.3,
    Graduate: 6.3,
    'Undergraduate and graduate': 11.3,
    'California K-12 public schools': 39.7,
  },
  {
    name: '1997',
    Undergraduate: 12.8,
    Graduate: 6,
    'Undergraduate and graduate': 10.9,
    'California K-12 public schools': 40.5,
  },
  {
    name: '1998',
    Undergraduate: 11.3,
    Graduate: 5.8,
    'Undergraduate and graduate': 9.8,
    'California K-12 public schools': 41.3,
  },
  {
    name: '1999',
    Undergraduate: 10.4,
    Graduate: 5.3,
    'Undergraduate and graduate': 9,
    'California K-12 public schools': 42.2,
  },
  {
    name: '2000',
    Undergraduate: 9.7,
    Graduate: 5.3,
    'Undergraduate and graduate': 8.5,
    'California K-12 public schools': 43.2,
  },
  {
    name: '2001',
    Undergraduate: 9.4,
    Graduate: 5.5,
    'Undergraduate and graduate': 8.3,
    'California K-12 public schools': 44.2,
  },
  {
    name: '2002',
    Undergraduate: 9.9,
    Graduate: 5.6,
    'Undergraduate and graduate': 8.7,
    'California K-12 public schools': 45.2,
  },
  {
    name: '2003',
    Undergraduate: 10.6,
    Graduate: 5.8,
    'Undergraduate and graduate': 9.2,
    'California K-12 public schools': 46.0,
  },
  {
    name: '2004',
    Undergraduate: 10.6,
    Graduate: 6,
    'Undergraduate and graduate': 9.2,
    'California K-12 public schools': 46.8,
  },
  {
    name: '2005',
    Undergraduate: 10.6,
    Graduate: 6,
    'Undergraduate and graduate': 9.2,
    'California K-12 public schools': 47.6,
  },
  {
    name: '2006',
    Undergraduate: 11,
    Graduate: 6,
    'Undergraduate and graduate': 9.5,
    'California K-12 public schools': 48.1,
  },
  {
    name: '2007',
    Undergraduate: 11.5,
    Graduate: 7.3,
    'Undergraduate and graduate': 9.9,
    'California K-12 public schools': 48.7,
  },
  {
    name: '2008',
    Undergraduate: 11.6,
    Graduate: 6.2,
    'Undergraduate and graduate': 10.1,
    'California K-12 public schools': 49.0,
  },
  {
    name: '2009',
    Undergraduate: 12,
    Graduate: 6.8,
    'Undergraduate and graduate': 10.5,
    'California K-12 public schools': 50.4,
  },
  {
    name: '2010',
    Undergraduate: 12,
    Graduate: 7.1,
    'Undergraduate and graduate': 10.6,
    'California K-12 public schools': 51.4,
  },
  {
    name: '2011',
    Undergraduate: 11.4,
    Graduate: 6,
    'Undergraduate and graduate': 9.9,
    'California K-12 public schools': 52.0,
  },
  {
    name: '2012',
    Undergraduate: 12,
    Graduate: 5.6,
    'Undergraduate and graduate': 10.2,
    'California K-12 public schools': 52.7,
  },
  {
    name: '2013',
    Undergraduate: 13,
    Graduate: 6,
    'Undergraduate and graduate': 11,
    'California K-12 public schools': 53.3,
  },
  {
    name: '2014',
    Undergraduate: 13.8,
    Graduate: 6.4,
    'Undergraduate and graduate': 11.7,
    'California K-12 public schools': 53.6,
  },
  {
    name: '2015',
    Undergraduate: 14,
    Graduate: 7.1,
    'Undergraduate and graduate': 12.1,
    'California K-12 public schools': 54,
  },
  {
    name: '2016',
    Undergraduate: 14.5,
    Graduate: 7.2,
    'Undergraduate and graduate': 12.5,
    'California K-12 public schools': 54.2,
  },
  {
    name: '2017',
    Undergraduate: 15.2,
    Graduate: 7.9,
    'Undergraduate and graduate': 13.2,
    'California K-12 public schools': 54.3,
  },
  {
    name: '2018',
    Undergraduate: 15.2,
    Graduate: 7.7,
    'Undergraduate and graduate': 13.1,
    'California K-12 public schools': 54.6,
  },
  {
    name: '2019',
    Undergraduate: 16.1,
    Graduate: 8.3,
    'Undergraduate and graduate': 13.9,
    'California K-12 public schools': 54.9,
  },
  {
    name: '2020',
    Undergraduate: 18.5,
    Graduate: 9.1,
    'Undergraduate and graduate': 16,
    'California K-12 public schools': 55.3,
  },
  {
    name: '2021',
    Undergraduate: 19.6,
    Graduate: 9.7,
    'Undergraduate and graduate': 16.6,
    'California K-12 public schools': 55.9,
  },
  {
    name: '2022',
    Undergraduate: 20,
    Graduate: 10.1,
    'Undergraduate and graduate': 17.2,
    'California K-12 public schools': null,
  },

];

export default allData;
